import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

const HomeInsurance = () => {
  return (
    <>
      <TopBanner content={"Home Insurance"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Protect Your Home, Secure Your Peace of Mind</h2>
          <p>
            Your home is one of your most valuable assets and home insurance
            protects it from unexpected damages caused by fire, theft, natural
            disasters, or accidents. It can also cover valuable contents like
            electronics, appliances, and furniture.
          </p>

          <p>
            Whether you own or rent, protecting your living space is a smart
            financial move.
          </p>

          <h3>Types of Home Insurance:</h3>
          <ul>
            <li>Building Insurance – Covers the structure of your house</li>
            <li>Content Insurance – Protects household items and valuables</li>
            <li>
              Comprehensive Home Insurance – Covers both structure and contents
            </li>
            <li>
              Tenant Insurance – Ideal for renters to insure their belongings
            </li>
          </ul>

          <h3>Why Home Insurance?</h3>
          <ul>
            <li>Covers repair or rebuilding costs due to damage</li>
            <li>Protection against theft, burglary, and fire</li>
            <li>Peace of mind during floods, earthquakes, or storms</li>
            <li>Affordable premiums for large protection</li>
          </ul>
          <p>A strong roof needs strong financial protection too.</p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default HomeInsurance;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
